<template>
	<v-menu>
		<template v-slot:activator="{ props }">
			<v-btn class="dotsIcon" variant="plain" size="large" density="compact" icon="mdi-dots-horizontal-circle-outline" color="#0ba7e1" v-bind="props" :data-cy="dataCy + `-dots-menu`"/>
		</template>
		<v-list density="compact">
			<v-list-item v-for="(item, i) in items" :key="i" @click="handleClick(item)" :data-cy="`popover-menu-${(item.label || item.title).toLowerCase()}`" :disabled="item.disabled">
				<div class="item">
					<v-icon size="small">{{ $t(item.icon) }}</v-icon>
					<v-list-item-title>{{ $t(item.title ?? item.label ?? '') }}</v-list-item-title>
				</div>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	name: 'PopoverMenu',
	props: {
		items: Array,
		dataCy: { type: String }
	},
	methods: {
		handleClick(item) {
			this.$emit('click', item.action, item)
		},
	},
}
</script>

<style scoped lang="scss">
.item {
	display: flex;
	align-items: center;
	gap: 10px;
	cursor: pointer;
}
.dotsIcon {
	margin-right: 5px;

	&:hover {
		transform: scale(1.2);
	}
}
</style>